class DialogHandler {
  constructor() {
    document.addEventListener('click', e => this.handleClick(e))
  }

  handleClick(e) {
    const link = e.target.closest('[href*="#dialog-"]')
    const trigger = e.target.closest('[data-dialog]')
    const closeBtn = e.target.closest('[data-dialog-close]')
    const dialog = e.target.closest('dialog')


    if (trigger || link) {
      e.preventDefault()
      e.stopPropagation()

      const id = trigger
        ? trigger.dataset.dialog
        : new URL(link.href).hash.slice(1)

      this.showDialog(id)
      return
    }

    if (closeBtn) {
      closeBtn.closest('dialog')?.close()
      return
    }

    if (e.target === dialog) {
      dialog?.close()
    }
  }

  showDialog(id) {
    const dialog = document.getElementById(id)
    if (!dialog || dialog.nodeName !== 'DIALOG') return

    if (!dialog.open) {
      dialog.showModal()
    }
  }
}

export default DialogHandler